import React from "react";
import { AiOutlineCheck, AiOutlineSearch } from "react-icons/ai";
import { BiChevronDown } from "react-icons/bi";
import { getSelectedLabel } from "../helpers/formHelper.js";

const FormInput = ({ label, type, id, disabled, value, onChange }) => {
  return (
    <div className={`${disabled && "cursor-not-allowed"}`}>
      <label
        htmlFor={id}
        className="uppercase font-retro-rounded font-medium text-xl"
      >
        {label}
      </label>
      <input
        type={type}
        id={id}
        className={`
        ${disabled ? "pointer-events-none" : ""}
        w-full h-12 px-4 outline-none retro-border-normal rounded-lg font-retro-rounded font-medium text-black placeholder:text-gray-600 text-xl`}
        value={value}
        onChange={onChange}
        placeholder={`Enter ${label}`}
      />
    </div>
  );
};

const FormSelect = ({ label, id, options, disabled, value, onChange }) => {
  const [selected, setSelected] = React.useState(
    getSelectedLabel(value, options)
  );
  const [inputValue, setInputValue] = React.useState(value);
  const [searchValue, setSearchValue] = React.useState("");
  const [open, setOpen] = React.useState(false);

  // On input change
  React.useEffect(() => {
    // If input value is empty, set selected to empty
    if (value === "") {
      setSelected("");
      setInputValue("");
    }
  }, [value]);

  return (
    <div className={`${disabled && "cursor-not-allowed"} relative`}>
      <label
        htmlFor={id}
        className="uppercase font-retro-rounded font-medium text-xl"
      >
        {label}
      </label>
      <div
        id={id}
        onClick={() => setOpen(!open)}
        className={`
        ${disabled ? "pointer-events-none" : ""}
        ${selected ? "text-black" : "text-gray-600"} 
        w-full h-12 px-4 retro-border-normal rounded-lg font-retro-rounded font-medium text-xl flex items-center justify-between cursor-pointer`}
      >
        <span className="truncate">
          {selected ? selected : `Select ${label}`}
        </span>
        <BiChevronDown
          size={20}
          className={`text-black ${open && "rotate-180"}`}
        />
      </div>
      <ul
        className={`bg-white w-full absolute left-0 top-[100%] z-50
        ${open ? "mt-2 max-h-60 border-[3px] border-black" : "mt-0 max-h-0"}
        overflow-y-auto rounded-lg font-retro-rounded font-medium text-black text-xl`}
      >
        {options.length >= 10 ? (
          <div className="flex items-center px-4 sticky top-0 bg-white border-b-2 border-black">
            <AiOutlineSearch size={24} className="text-black" />
            <input
              type="text"
              placeholder={`Search ${label}`}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-full p-3 outline-none capitalize font-retro-rounded font-medium text-black text-xl placeholder:text-gray-600"
            />
          </div>
        ) : null}
        {options.map((option) => (
          <li
            key={option.value}
            onClick={(e) => {
              if (option.value !== inputValue) {
                setInputValue(option.value);
                setSelected(option.label);
                setOpen(false);
                setSearchValue("");
                onChange(option.value);
              }
            }}
            className={`p-4 hover:bg-retro-grey cursor-pointer 
            ${option.value === inputValue && "bg-retro-blue"}
            ${
              option.label.toLowerCase().includes(searchValue.toLowerCase())
                ? "block"
                : "hidden"
            }`}
          >
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

const FormCheckbox = ({ label, id, disabled, checked, onChange }) => {
  return (
    <div
      className={`
        ${disabled ? "cursor-not-allowed" : ""}
        flex items-center`}
    >
      <div
        className="w-7 h-7 relative border-2 border-black mr-4 cursor-pointer"
        onClick={onChange}
      >
        <AiOutlineCheck
          size={24}
          className={`text-black absolute ${checked ? "block" : "hidden"}`}
        />
        <input
          type="checkbox"
          id={id}
          className={`
        ${disabled ? "pointer-events-none" : ""}
        appearance-none w-7 h-7 cursor-pointer`}
          checked={checked}
          onChange={onChange}
        />
      </div>
      <label
        htmlFor={id}
        className={`
        ${disabled ? "pointer-events-none" : ""} 
        w-full normal-case font-retro-rounded font-medium text-xl`}
      >
        {label}
      </label>
    </div>
  );
};

export { FormInput, FormSelect, FormCheckbox };
